<div class="pdpm-container">
  <h2 class="pdpm-title">PDPM 100-Day Calculator</h2>

  <!-- Removed (ngSubmit), keep form just for grouping controls -->
  <form [formGroup]="pdpmForm">
    <mat-form-field appearance="fill" class="pdpm-field">
      <mat-label>Patient Name</mat-label>
      <input matInput formControlName="patientName" placeholder="Enter patient name">
    </mat-form-field>

    <mat-form-field appearance="fill" class="pdpm-field">
      <mat-label>Age</mat-label>
      <input matInput type="number" formControlName="age" placeholder="Enter age">
    </mat-form-field>

    <mat-form-field appearance="fill" class="pdpm-field">
      <mat-label>Diagnosis</mat-label>
      <input matInput formControlName="diagnosis" placeholder="Enter diagnosis">
    </mat-form-field>

    <mat-form-field appearance="fill" class="pdpm-field">
      <mat-label>Assessment Date</mat-label>
      <input matInput type="date" formControlName="assessmentDate">
    </mat-form-field>

    <mat-form-field appearance="fill" class="pdpm-field">
      <mat-label>Category</mat-label>
      <mat-select formControlName="category">
        <mat-option value="Nursing">Nursing</mat-option>
        <mat-option value="Therapy">Therapy</mat-option>
        <mat-option value="Special Care">Special Care</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="pdpm-actions">
      <!-- Use type="button" so it won't refresh the page -->
      <button mat-raised-button color="primary" type="button"
              (click)="calculatePDPM()" [disabled]="spinner">
        Calculate
      </button>

      <button mat-stroked-button color="warn" type="button"
              (click)="resetForm()">
        Reset
      </button>
    </div>
  </form>

  <div class="pdpm-result" *ngIf="calculatedScore !== null">
    <h3>Calculated PDPM Score: {{ calculatedScore }}</h3>
  </div>

</div>
